import React from 'react';
import { connect } from 'react-redux';
import { REFUND_ASSIST_VIEW_ID } from '../../components/shipping-grid/views/view-id-constants';
import { useSelectedShippingViewId } from '../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';
import Global from '../../store/global-selectors';
import { getRefundAssistStatusString } from '../../constants/refund-assist-status-constants';

import ShipmentStatusLabel from '../../components/shipment-status-label';

const orderGridStatusToShipmentStatusMap = {
  Cancelled: 'cancelled',
  AwaitingPayment: 'awaitingpayment',
  OnHold: 'onhold',
  Shipped: 'shipped',
  PendingFulfillment: 'pendingfulfillment',
  RejectedFulfillment: 'rejectedfulfillment',
};

const getRefundAssistStatus = (fulfillment) => {
  const refundStatusId = fulfillment?.shipmentRefundStatusTypeId;
  return getRefundAssistStatusString(refundStatusId);
};

const findShipDate = (fulfillments, standalone) => {
  if (standalone) {
    return undefined;
  }

  const { shipDateTime } = fulfillments.find((f) => !f.isLabelVoided) || {};

  return shipDateTime;
};

const findTrackingProps = (fulfillments, standalone) => {
  if (standalone) {
    return {
      trackingCodeText: undefined,
      trackingUrl: undefined,
      trackingStatus: undefined,
    };
  }

  const { trackingInformation } = fulfillments.find((f) => !f.isLabelVoided) || { trackingInformation: {} };
  if (!trackingInformation) {
    return {
      trackingCodeText: undefined,
      trackingUrl: undefined,
      trackingStatus: undefined,
    };
  }

  return {
    trackingCodeText: trackingInformation.trackingNumber,
    trackingUrl: trackingInformation.url,
    trackingStatus: trackingInformation.status,
  };
};

const mapStateToProps = (state, { fulfillmentPlanId, standalone, isRefundAssistView }) => {
  const entityFulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }) ?? {};

  const { fulfillmentIds } = entityFulfillmentPlan;
  const fulfillments = Global.selectEntitiesFulfillmentsByIds(state, { fulfillmentIds }) || [];

  const status = orderGridStatusToShipmentStatusMap[entityFulfillmentPlan.orderGridStatus];

  // Get refund assist status for additional tag
  let refundAssistStatus;
  if (isRefundAssistView && fulfillments.length > 0) {
    const firstFulfillment = fulfillments[0];
    refundAssistStatus = getRefundAssistStatus(firstFulfillment);
  }

  return {
    date: findShipDate(fulfillments, standalone),
    status,
    refundAssistStatus,
    ...findTrackingProps(fulfillments, standalone),
  };
};

const ConnectedShipmentStatusLabel = connect(mapStateToProps)(ShipmentStatusLabel);

// Wrapper component to use the hook and pass isRefundAssistView
export const ShipmentStatusLabelContainer = (props) => {
  const statusViewId = useSelectedShippingViewId();
  const isRefundAssistView = statusViewId === REFUND_ASSIST_VIEW_ID;

  return <ConnectedShipmentStatusLabel {...props} isRefundAssistView={isRefundAssistView} />;
};
